import {ReactNode} from 'react'
import {ComponentItem, CreateComponent} from '../useComponent'
import TableHeader from './TableHeader'
import TableLayout from './TableLayout'
import TableItem from './TableItem'

interface ITableProps {
    headers?: ComponentItem[]
    items?: ReactNode[]
    className?: ReactNode
    gridCols: string
    onClick?: () => void
}

const WizTable: React.FC<ITableProps> = ({className, headers, items, gridCols}) => {
    return (
        <div className={`${className}`}>
            <TableHeader className={`grid-cols-${gridCols}`}>
                {headers.map(el => CreateComponent(el.component, el.props))}
            </TableHeader>
            <TableLayout>
                {items.length !== 0 ? (
                    items.map(el => (
                        <div className="relative">
                            <TableItem className={`grid-cols-${gridCols}`}>{el}</TableItem>
                        </div>
                    ))
                ) : (
                    <div>empty item</div>
                )}
            </TableLayout>
        </div>
    )
}

export default WizTable
